import { render } from "./aero.vue?vue&type=template&id=6f1f94fe&scoped=true"
import script from "./aero.vue?vue&type=script&lang=js"
export * from "./aero.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-6f1f94fe"

export default script